import { render } from "./indexReserveTypesComponent.vue?vue&type=template&id=20e9d708"
import script from "./indexReserveTypesComponent.vue?vue&type=script&lang=js"
export * from "./indexReserveTypesComponent.vue?vue&type=script&lang=js"

import "./indexReserveTypesComponent.vue?vue&type=style&index=0&id=20e9d708&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__